import React, { useMemo, useState } from "react";
import { useTable, useGlobalFilter, useFilters, usePagination } from "react-table";
import DATA from "./pharmacies.json";
import { COLUMNS } from './columns';
import { GlobalFilter } from "./GlobalFilter";

function Table() {
    const columns = useMemo(() => COLUMNS, []);
    const data = useMemo(() => DATA, []); 
    const [filterColumn, setFilterColumn] = useState(null);
    const [filterValue, setFilterValue] = useState('');

    const cityColumn = columns.find((column) => column.accessor === 'Πόλη');
    const cityOptions = React.useMemo(() => {
        const options = new Set();
        data.forEach((item) => {
            if(item[cityColumn.accessor]) {
                return options.add(item[cityColumn.accessor]);
            }           
        });
        return Array.from(options).sort();
      }, [data, cityColumn.accessor]);
    
      const defaultColumnFilter = React.useMemo(
        () => ({ filter: '', setFilter: () => null }),
        []
      );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount,
        setPageSize,
        state,
        setGlobalFilter,
        setFilter,
        prepareRow,
    } = useTable({
        columns,
        data,
        defaultColumn: defaultColumnFilter
    }, useFilters,useGlobalFilter, usePagination);

    const { globalFilter, pageIndex, pageSize } = state;

    const handleFilterChange = (event) => {
        setFilterColumn(cityColumn.accessor);
        setFilterValue(event.target.value);
      };
    
      React.useEffect(() => {
        if (filterColumn !== null) {
          setFilter(filterColumn, filterValue);
        }
      }, [filterColumn, filterValue, setFilter]);

    return (
        <>
        <div className="d-flex py-2 align-items-end justify-content-between"> 
            <div className="d-flex">
                <div>
                    <label className="form-label" htmlFor="filterColumn">Επαρχία</label>
                    <select className="form-select" id="filterColumn" onChange={handleFilterChange}>
                        <option value="">Ολοι</option>
                        {cityOptions.map((option) => (
                            <option key={option} value={option}>
                            {option}
                            </option>
                        ))}
                    </select>
                </div>    
            
                <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
            </div>
            <div>
                <select className="form-select w-auto" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                    {
                        [10, 20, 50].map(pageSize => (
                            <option key={pageSize} value={pageSize}>
                                Show {pageSize}
                            </option>
                        ))
                    }
                </select>
            </div>
        </div>
        <div className="p-2">
            <table {...getTableProps()} className="table" >
                <thead>
                    {
                        headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps}>
                                {
                                    headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps()}>{column.render('Header')}
                                        </th>
                                    ))
                                }                           
                            </tr>
                        ))
                    }
                    
                </thead>
                <tbody {...getTableBodyProps()}>
                    {
                        page.map((row) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {
                                        row.cells.map((cell) => {
                                            return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                                        })
                                    }
                                    
                                </tr>
                            )
                        })
                    }

                </tbody>
            </table>
            <div className="d-flex align-items-center">
                <div>
                    <span className="me-2">
                        Page{' '}
                        <strong>
                            {pageIndex + 1} of {pageOptions.length}
                        </strong>               
                    </span>
                    <button className="btn btn-outline-secondary me-2" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>{'<<'}</button>
                    <button className="btn btn-outline-secondary me-2" onClick={() => previousPage()} disabled={!canPreviousPage}>{'<'}</button>
                    <button className="btn btn-outline-secondary me-2" onClick={() => nextPage()} disabled={!canNextPage}>{'>'}</button>
                    <button className="btn btn-outline-secondary" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>{'>>'}</button>
                </div>
                

            </div>
        </div>

        </>
    );
}

export default Table;